'use client';

import { useCallback, useEffect, useState } from 'react';
import AlertManager from './AlertManager';
import AlertType from './AlertType';
import Alerts, { IAlertsProps } from './Alerts';

export type AlertPlacement =
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

interface IProps {
  enterTimeout?: number,
  exitTimeout?: number,
  containerClassName?: string,
  alertClassName?: string,
  placement?: AlertPlacement,
}

const AlertContainer = ({
  enterTimeout = 300,
  exitTimeout = 300,
  containerClassName,
  alertClassName,
  placement = 'topCenter',
}: IProps) => {
  const [alerts, setAlerts] = useState(AlertManager.getAlertsList());
  const [bounceId, setBounceId] = useState<string | null>(null);

  const handleBounce = useCallback((id: string) => {
    setBounceId(null);
    requestAnimationFrame(() => setBounceId(id));
  }, []);

  useEffect(() => {
    const handleStoreChange = (updatedAlerts: IAlertsProps[]) => {
      setAlerts([...updatedAlerts]);
    };
    AlertManager.addChangeListener(handleStoreChange);
    AlertManager.on(AlertType.BOUNCE, handleBounce);
    return () => {
      AlertManager.removeChangeListener(handleStoreChange);
      AlertManager.off(AlertType.BOUNCE, handleBounce);
    };
  }, [handleBounce]);

  const handleHide = (alert: IAlertsProps) => {
    AlertManager.remove(alert);
  };

  return (
    <Alerts
      enterTimeout={ enterTimeout }
      exitTimeout={ exitTimeout }
      alerts={ alerts }
      onHide={ handleHide }
      containerClassName={ containerClassName }
      alertClassName={ alertClassName }
      placement={ placement }
      bounceId={ bounceId }
    />
  );
};

export default AlertContainer;
